import { BoxProps } from "./Box";

export const data: BoxProps[] = [
  {
    title: "1. Do You Feel Anxious and Overwhelmed?",
    description: `<p>Over <b>40 million adults in the US feel anxious regularly.</b> 
    Constant worry and tension can leave you mentally and physically drained. 
    However, there is a tested solution. 
    <button class="scroll-button">Ashwagandha</button>, 
    a powerful adaptogen, lowers cortisol naturally, supports neurotransmitter balance, and 
    <b>calms your nervous system</b>. [2,3,4]</p>`,
    imagePlacement: "right",
    img: {
      src: `${window.template_root}/v1/negativeFeelings/feeling1.jpg`,
      alt: "negative feeling 1",
    },
    percents: {
      number: "55%",
      text: "Improved Mental Clarity and Focus",
    },
  },
  {
    title: "2. Battling Brain Fog and Lack of Focus?",
    description: `<p>About <b>60% of adults experience brain fog and mental fatigue</b> 
    caused by stress, poor sleep, and mental strain. Thankfully, 
    <button class="scroll-button">Ashwagandha</button> not only regulates cortisol but also improves 
    blood flow to the brain and reduces oxidative stress. These effects 
    <b>restore mental sharpness and boost productivity</b>. [5]</p>`,
    imagePlacement: "left",
    img: {
      src: `${window.template_root}/v1/negativeFeelings/feeling2.jpg`,
      alt: "negative feeling 2",
    },
    percents: {
      number: "55%",
      text: "Improved Mental Clarity and Focus",
    },
  },
  {
    title: "3. Feeling Drained and Exhausted?",
    description: `<p>The fast pace of modern life traps <b>3 out of 5 people</b> in a cycle of 
    <b>stress and sleep deprivation</b>. 
    <button class="scroll-button">Ashwagandha</button> helps you recover naturally. 
    It reduces cortisol levels, improves adrenal and thyroid function, and boosts 
    cellular energy production. Within a week, you feel <b>revitalized and productive</b>. [6]</p>`,
    imagePlacement: "right",
    img: {
      src: `${window.template_root}/v1/negativeFeelings/feeling3.jpg`,
      alt: "negative feeling 3",
    },
    percents: {
      number: "58%",
      text: "Boost in Energy Levels",
    },
  },
  {
    title: "4. Looking for a Natural Way to Boost Your Mood?",
    description: `<p><b>Low energy and mood swings affect 30% of adults</b> on a daily basis, 
    disrupting emotional well-being. Many have found relief with 
    <button class="scroll-button">Ashwagandha</button>. The supplement balances the endocrine system, 
    restoring energy and <b>promoting a calmer, more stable mood</b>. [7]</p>`,
    imagePlacement: "left",
    img: {
      src: `${window.template_root}/v1/negativeFeelings/feeling4.jpg`,
      alt: "negative feeling 4",
    },
    percents: {
      number: "48%",
      text: "Improved Mood and Emotional Balance",
    },
  },
  {
    title: "5. Feeling Out of Sync with Your Sleep?",
    description: `<p><b>1 in 3 adults suffer from poor sleep</b>, which impacts everyday life at work and home. 
    <button class="scroll-button">Ashwagandha</button> combats sleep issues by supporting 
    <b>melatonin production</b> and restoring your body’s natural sleep-wake cycle. The result? 
    Deeper, more <b>restorative sleep every night</b>. [8]</p>`,
    imagePlacement: "right",
    img: {
      src: `${window.template_root}/v1/negativeFeelings/feeling5.jpg`,
      alt: "negative feeling 5",
    },
    percents: {
      number: "72%",
      text: "Report Better Sleep Quality",
    },
  },
];
